import { ILookUp } from '../schemas/entity_set';
import { ILookUpService } from '../settings/lookup_service';
import { IMemberService } from '../members/member_service';
import { ITransactionService } from '../transactions/transaction_service';
import _ = require("underscore")

interface IModel {
    name: string
    fields: IModelField[]
}

interface IModelField {
    name: string
    property: string
    required: boolean
    type: FieldType
    lookup?: string
}

enum FieldType {
    Text,
    Number,
    Select,
    Date
}

class Models {
    static get Member() { return "Member" }
    static get Transaction() { return "Transaction" }
    static get Interest() { return "Interest" }
}

let win: any = window

class DataUploadCtrl {
    errorCount: number;
    saving: boolean;
    data: any[]
    model: IModel

    models: IModel[] = [
        {
            name: Models.Member,
            fields: [
                { name: "Number", property: "number", required: true, type: FieldType.Text },
                { name: "Name", property: "name", required: true, type: FieldType.Text },
                // { name: "LastName", property: "lastName", required: false, type: FieldType.Text },
                // { name: "OtherName", property: "otherName", required: false, type: FieldType.Text },
                { name: "Gender", property: "gender", required: true, type: FieldType.Text },
                // { name: "PhoneNumber", property: "phoneNumber", required: false, type: FieldType.Text },
                // { name: "Email", property: "email", required: false, type: FieldType.Text },
                // { name: "RegistrationDate", property: "registrationDate", required: false, type: FieldType.Date },
                // { name: "Guardian", property: "guardian", required: false, type: FieldType.Text },
                // { name: "GuardianContact", property: "guardianContact", required: false, type: FieldType.Text },
                { name: "Balance", property: "balance", required: false, type: FieldType.Number }
            ]
        },
        {
            name: Models.Transaction,
            fields: [
                { name: "Number", property: "number", required: true, type: FieldType.Text },
                { name: "Name", property: "name", required: false, type: FieldType.Text },
                { name: "Type", property: "type", required: true, type: FieldType.Text },
                { name: "Date", property: "date", required: false, type: FieldType.Date },
                { name: "Amount", property: "Amount", required: false, type: FieldType.Number },
            ]
        },
        {
            name: Models.Interest,
            fields: [
                { name: "Number", property: "number", required: true, type: FieldType.Text },
                { name: "Name", property: "name", required: false, type: FieldType.Text },
                { name: "Amount", property: "Amount", required: false, type: FieldType.Number },
            ]
        },
    ]

    lookUps: string[] = [];
    static $inject = ["LookUpService", "XLSXReaderService", "$scope", "MemberService", "TransactionService"];

    constructor(private lookupService: ILookUpService,
        private XLSXReaderService: any, private $scope: any,
        private memberService: IMemberService,
        private transactionService: ITransactionService) {
        this.loadLookUps()


        $scope.$watch(() => this.data, (n: any, o: any) => {
            this.errorChecker()
        }, true)

        this.$scope.fileChanged = (ele: any) => {
            this.readFileData(ele)
        }
    }

    uploadData() {
        this.saving = true
        switch (this.model.name) {
            case Models.Member:
                this.memberService.upload(this.data).then((res) => { this.afterUpload(res.success) })
                break;
            case Models.Transaction:
                this.transactionService.upload(this.data).then((res) => { this.afterUpload(res.success) })
                break;
            case Models.Interest:
                this.transactionService.uploadInterest(this.data).then((res) => { this.afterUpload(res.success) })
                break;
            default:
                break;
        }
    }

    private afterUpload(success: boolean) {
        this.saving = false
        if (success) { this.clearFile() }
    }

    remove(index: number) { this.data.splice(index, 1) }

    clearFile() {
        $("#uploadDoc").val(null)
        this.data = null
    }

    checkEntry(item: any) {
        var check = { error: false, message: "" };

        this.model.fields.forEach(field => {
            if (field.required && !item[field.property]) {
                check.error = true;
                check.message += `${field.name} is required. `;
            }
        });

        return check;
    };

    private readFileData(files: any) {
        let excelFile = files[0];
        this.XLSXReaderService.readFile(excelFile, true, true).then((xlsxData: any) => {
            let data: Array<any> = xlsxData.sheets["Sheet1"];
            this.data = data.map((rec: any) => { return this.refactorRecord(rec) })
        });
    };

    private refactorRecord(data: any) {
        let self: any = this
        let rec: any = {};
        this.model.fields.forEach((field) => {
            switch (field.type) {
                case FieldType.Text:
                    rec[field.property] = data[field.name]
                    break;
                case FieldType.Number:
                    rec[field.property] = +data[field.name]
                    break;
                case FieldType.Select:
                    rec[field.property] = this.getLookUpId(self[field.lookup], data[field.name])
                    break;
                case FieldType.Date:
                    rec[field.property] = new Date(data[field.name])
                    break;
                default:
                    break;
            }
        })

        rec._entry = this.checkEntry(rec)
        return rec;
    }

    private errorChecker() {
        this.errorCount = 0;
        if (this.data) {
            this.data = this.data.map((item) => {
                item._entry = this.checkEntry(item)
                if (item._entry.error) {
                    this.errorCount++
                }
                return item;
            })
        }
    }

    private getLookUpId(data: Array<any>, name: string) {
        let item = _.findWhere(data, { name });
        return (item) ? item.id : 0
    }

    private getLookUpName(data: Array<any>, id: number) {
        let item = _.findWhere(data, { id });
        return (item) ? item.name : ""
    }

    private loadLookUps() {
        let self: any = this;
        self['gender'] = ['Male', 'Female'];
        self['types'] = ['Deposit', 'Withdrawal'];
        this.lookUps.forEach((lookup) => {
            this.lookupService.fetch(lookup).then((res) => {
                if (res.success) { self[lookup] = res.data }
            })
        })
    }
}

export { DataUploadCtrl }


// WEBPACK FOOTER //
// ./app/settings/data_upload_ctrl.ts